/// <amd-module name="Dashboards/DashboardView/src/components/headers/ConfigModeHeader" />
import * as React from "react";

export class ConfigModeHeader extends React.PureComponent<{}> {
    public render(): JSX.Element {
        return <div className="dashboard-config-mode-header flex-noshrink" />;
    }
}
